
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalClientsCount }}</span>
          <span class="stats-card-label">Total Clients</span>
          <span class="stats-card-sublabel">All clients</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-building"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeClientsCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveClientsCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="serviceGroupFilter" class="filter-label">Service Group</label>
          <p-select id="serviceGroupFilter" [(ngModel)]="selectedServiceGroupFilter"
            (ngModelChange)="onServiceGroupFilterChange()" [options]="serviceGroups" optionLabel="name"
            optionValue="id" placeholder="All Service Groups" [showClear]="true" [filter]="true"
            filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredClients"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} clients"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable client-management-table no-column-lines">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Title
            <p-sortIcon field="name" />
          </th>
          <th pSortableColumn="description">
            Description
            <p-sortIcon field="description" />
          </th>
          <th pSortableColumn="folderNumber" style="width: 100px">
            Folder
            <p-sortIcon field="folderNumber" />
          </th>
          <th pSortableColumn="serviceGroupName">
            Service Group
            <p-sortIcon field="serviceGroupName" />
          </th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-client>
        <tr [class.row-inactive]="client.isActive === false">
          <td class="td-truncate" [pTooltip]="client.name || ''">{{ client.name }}</td>
          <td class="td-truncate td-description" [pTooltip]="(client.description || '-')">{{ client.description || '-' }}</td>
          <td [pTooltip]="(client.folderNumber || '-')">{{ client.folderNumber || '-' }}</td>
          <td class="td-truncate" [pTooltip]="(client.serviceGroupName || '-')">{{ client.serviceGroupName || '-' }}</td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="client.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="client.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleActiveStatus(client)"
                size="small"
                [pTooltip]="client.isActive ? 'Active' : 'Inactive'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="showEditDialog(client)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="5" class="table-empty-cell">
            <div class="empty-state">
              <i class="pi pi-inbox empty-icon"></i>
              <p class="empty-message">No clients found.</p>
              <p class="empty-description">Try adjusting filters or add a new client.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Client' : 'Edit Client'"
  [modal]="true" styleClass="dialog-md" [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedClient.name.trim()">
          <label for="name">Title <span class="required-star">*</span></label>
          <input pInputText id="name" [(ngModel)]="selectedClient.name" placeholder="Enter client title" (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedClient.name.trim()">Title is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedClient.description" rows="3"
            class="p-inputtext" placeholder="Enter client description"></textarea>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="folderNumber">Folder #</label>
          <input pInputText id="folderNumber" [(ngModel)]="selectedClient.folderNumber"
            placeholder="Optional folder number" />
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="serviceGroup">Service Group</label>
          <p-select id="serviceGroup" [(ngModel)]="selectedClient.serviceGroupId" (ngModelChange)="onServiceGroupChange()"
            [options]="serviceGroups" optionLabel="name" optionValue="id" placeholder="Select service group"
            [showClear]="true" [filter]="true" filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <div class="flex align-items-center gap-2">
            <p-checkbox id="disableMsaNotifications" [(ngModel)]="selectedClient.disableMsaNotifications" [binary]="true" />
            <label for="disableMsaNotifications">Disable MSA Renewal Notifications</label>
          </div>
        </div>
      </div>
      <div class="form-row" *ngIf="dialogMode === 'edit'">
        <div class="field">
          <label>Status</label>
          <p-button [label]="selectedClient.isActive ? 'Active' : 'Inactive'"
            [severity]="selectedClient.isActive ? 'success' : 'secondary'" [outlined]="!selectedClient.isActive"
            (onClick)="selectedClient.isActive = !selectedClient.isActive" size="small" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetClientForm()"
        [text]="true" severity="secondary" styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()"
        severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveClient()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
